import { combineReducers } from 'redux';

import { cardCompletionReducer } from './cardCompletion/reducer';
import { cardFlagReducer } from './cardFlag/reducer';

export const overviewCardReducer = combineReducers({
  completion: cardCompletionReducer,
  flag: cardFlagReducer
});
